import styled from '@emotion/styled'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { router } from 'shared/routes'
import { removeToast, selectToasts } from 'shared/state/toastSlice'
import { getPxAsRem } from 'shared/utils'
import ToastAlert from './ToastAlert'

const ToastContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: ${getPxAsRem(4)};
`

const ToastProvider = () => {
    const toasts = useSelector(selectToasts)
    const dispatch = useDispatch()

    useEffect(() => {
        const toastWithNavigate = toasts.findIndex((toast) => !!toast.navigate)
        if (toastWithNavigate > -1) {
            router.navigate(toasts[toastWithNavigate].navigate as string)
        }
    }, [toasts])

    return (
        <ToastContainer>
            {toasts?.map((toast) => (
                <ToastAlert
                    {...toast}
                    key={toast.id}
                    onClose={() => dispatch(removeToast(toast.id))}
                />
            ))}
        </ToastContainer>
    )
}

export default ToastProvider
